import { HttpErrorResponse } from '@angular/common/http';
import { getApiErrorMessage } from '../../core/utils/http-error-message.util';

const STATUS_CODE_PATTERN = /\b([1-5]\d{2})\b/;

export function buildReviewDeleteKey(resourceType: string, resourceId: string): string {
  return `${(resourceType || '').toLowerCase().trim()}:${resourceId || ''}`;
}

export function getDeleteReviewHttpStatus(error: unknown): number | null {
  if (error instanceof HttpErrorResponse) {
    return Number.isFinite(error.status) ? error.status : null;
  }

  const rawStatus = (error as { status?: unknown })?.status;
  if (typeof rawStatus === 'number' && Number.isFinite(rawStatus)) {
    return rawStatus;
  }

  const message = (error as { message?: unknown })?.message;
  if (typeof message === 'string') {
    const match = message.match(STATUS_CODE_PATTERN);
    if (match?.[1]) {
      return Number(match[1]);
    }
  }

  return null;
}

export function getDeleteReviewErrorMessage(error: unknown): string {
  // Sempre a mensagem do backend quando vier; senão, fallback por status.
  const status = getDeleteReviewHttpStatus(error);

  let fallback = 'Falha ao excluir review. Tente novamente.';
  if (status === 404) {
    fallback = 'Review não encontrado ou já removido';
  } else if (status === 400) {
    fallback = 'Requisição inválida para exclusão do review';
  }

  return getApiErrorMessage(error, fallback);
}
